export class ExcelHeadersModel {
    public id: any;
    public pagename: string;
    public name: string;
    public dataKey: string;
    public position: string;
    public isSortable: any;
    public edit: any;
    public isView: any;
    public status: string;
    public excelstatus: string;
    public headerstatus: string;
    public vieworder: any;
    public created_by: string;
    public updated_by: string;
    public created_dt: Date;
    public updated_dt: Date;

    public jsonsqlid:any;

    constructor() {
        this.id = null;
        this.pagename = null;
        this.name = null;
        this.dataKey = null;
        this.position = null;
        this.isSortable = null;
        this.edit = null;
        this.isView = null;
        this.status = null;
        this.excelstatus = null;
        this.headerstatus = null;
        this.vieworder = null;
        this.created_by = "";
        this.updated_by = null;
        this.created_dt = null;
        this.updated_dt = null;
    }
}